import React, { ReactNode } from "react";
import {
  Box,
  Typography,
  Button,
  Grid,
  Paper,
  InputBase,
  useTheme,
} from "@mui/material";
import { useStockControlStore } from "../../hooks/useStockControlStore";
import SelectorDeposito from "./SelectorDeposito";
import { useConfiguracion } from "../../helpers/useConfiguration";
import CustomTextField from "./CustomTextField";
import ButtonsFormulario from "./ButtonsFormulario";
import CustomButtonsFormulario from "./CustomButtonsFormulario";

const FormularioBase = ({
  mostrarTipoControl = true,
  tituloAlternativo,
  children,
  onCancelar,
  onProximo,
  onInexistente,
  onNoControlar,
  proximoDeshabilitado = false,
  mostrarBotones = true,
  camposPersonalizados,
  loading = false,
  customButtonLabels = {},
}) => {
  const {
    articuloActual,
    stockTeorico,
    stockReal,
    setStockReal,
    msgError,
    mensajeComprobante,
    openCancelarDialog,
  } = useStockControlStore();
  const theme = useTheme();
  const { configuracion } = useConfiguracion();

  // Handlers por defecto
  const handleCancelar = onCancelar || openCancelarDialog;
  const handleProximo = onProximo || (() => {});
  const handleInexistente =
    onInexistente ||
    (() => {
      setStockReal(0);
      handleProximo();
    });
  const handleNoControlar = onNoControlar || (() => {});

  // Si hay mensaje de comprobante, mostrar modal
  if (mensajeComprobante) {
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        height="100%"
        minHeight="300px"
      >
        <Paper elevation={3} sx={{ p: 3, width: 300, textAlign: "center" }}>
          <Typography variant="h6" fontWeight={600} gutterBottom>
            Control de stock
          </Typography>
          <Typography variant="body2" sx={{ whiteSpace: "pre-line" }}>
            {mensajeComprobante}
          </Typography>
          <Typography
            sx={{ mt: 4, color: "#3f51b5", fontWeight: 600, fontSize: 14 }}
          >
            ACEPTAR
          </Typography>
        </Paper>
      </Box>
    );
  }

  return (
    <Box
      bgcolor="#fff"
      display="flex"
      flexDirection="column"
      alignItems="center"
    >
      {/* Selector de depósito */}
      <Box width={310} mb={2}>
        <SelectorDeposito />
      </Box>

      {/* Encabezado */}
      <Typography
        align="center"
        fontWeight="bold"
        sx={{
          color: theme.bandera.colorSecundario,
          mb: 1,
          textTransform: "uppercase",
          fontSize: 18,
        }}
      >
        {mostrarTipoControl
          ? `CONTROL DE STOCK [${configuracion?.tipoControlDescripcion?.toUpperCase() || "CARGANDO..."}]`
          : tituloAlternativo?.toUpperCase()}
      </Typography>

      {/* Línea divisoria */}
      <Box
        sx={{
          height: "2px",
          width: "335px",
          backgroundColor: theme.bandera.colorSecundario,
          opacity: 0.4,
          mb: 2,
          borderRadius: 2,
          mx: "auto",
        }}
      />
      {camposPersonalizados}
      <Box width={310} mb={2}>
        {children}
        <CustomTextField
          label="STOCK TEÓRICO"
                    sx={{ color: "black" }}

          value={stockTeorico ?? ""}
          loading={loading}
          disabled
        />
        <CustomTextField
          sx={{ color: "black" }}
          label="STOCK REAL"
          type="number"
          value={stockReal ?? ""}
          loading={loading}
          onChange={e => {
            const val = e.target.value;
            setStockReal(val === "" ? null : Number(val));
          }}
        />

        {msgError && (
          <Typography sx={{ color: "red", mt: 1 }}>{msgError}</Typography>
        )}

        {mostrarBotones && (
          <CustomButtonsFormulario
            onCancelar={handleCancelar}
            onProximo={handleProximo}
            onInexistente={handleInexistente}
            onNoControlar={handleNoControlar}
            proximoDeshabilitado={
              proximoDeshabilitado || stockReal === null || isNaN(stockReal)
            }
            loading={loading}
            customLabels={customButtonLabels}
          />
        )}
      </Box>
    </Box>
  );
};

export default FormularioBase;
